export default __webpack_public_path__ + "assets/images/afb495db5670f7a2c0fa46a65a4066c4.jpg";